module.exports = __webpack_public_path__ + "img/goods11-6.6bc5d07f.jpg";